/**
 * Display helpers for Performance Attribution (Spec 2.5). Pure functions — tested.
 */

import { AttributionBucket } from '../types';

export interface AttributionRow extends AttributionBucket {
  key: string;
}

export const DIMENSION_LABELS: Record<string, string> = {
  strategy: 'By Strategy',
  regime: 'By Market Regime',
  condition: 'By Entry Condition',
  dte: 'By DTE',
  consensus: 'By Consensus',
  quarter: 'By Quarter',
};

/** Convert a dimension's bucket map into rows sorted by trade count (desc). */
export const sortBuckets = (
  buckets: Record<string, AttributionBucket> | undefined | null,
): AttributionRow[] => {
  if (!buckets) return [];
  return Object.entries(buckets)
    .map(([key, b]) => ({ key, ...b }))
    .sort((a, b) => b.trades - a.trades);
};

/** Win-rate color: green ≥60%, yellow ≥45%, red below. */
export const winRateColor = (winRate: number): string =>
  winRate >= 60 ? 'text-green-400' : winRate >= 45 ? 'text-yellow-400' : 'text-red-400';

/** "rsi_oversold" → "Rsi Oversold", "2026-Q1" → "2026-Q1". */
export const prettyBucketKey = (key: string): string =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

/** Whether an attribution result has any non-empty dimension to show. */
export const hasAttributionData = (
  attribution: Record<string, Record<string, AttributionBucket>> | undefined | null,
): boolean => {
  if (!attribution) return false;
  return Object.values(attribution).some((dim) => dim && Object.keys(dim).length > 0);
};
